var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.1688V16.14H5.49997V19.1688C5.49997 19.2586 5.52883 19.3323 5.58653 19.39C5.64423 19.4477 5.71795 19.4765 5.8077 19.4765H19.1923C19.282 19.4765 19.3557 19.4477 19.4134 19.39C19.4711 19.3323 19.5 19.2586 19.5 19.1688ZM19.5 14.64V10.3131H5.49997V14.64H19.5ZM19.5 8.81311V5.78426C19.5 5.69451 19.4711 5.62079 19.4134 5.56309C19.3557 5.50539 19.282 5.47654 19.1923 5.47654H5.8077C5.71795 5.47654 5.64423 5.50539 5.58653 5.56309C5.52883 5.62079 5.49997 5.69451 5.49997 5.78426V8.81311H19.5ZM5.8077 20.9765C5.30257 20.9765 4.875 20.8015 4.525 20.4515C4.175 20.1015 4 19.6739 4 19.1688V5.78426C4 5.27913 4.175 4.85156 4.525 4.50156C4.875 4.15156 5.30257 3.97656 5.8077 3.97656H19.1923C19.6974 3.97656 20.125 4.15156 20.475 4.50156C20.825 4.85156 21 5.27913 21 5.78426V19.1688C21 19.6739 20.825 20.1015 20.475 20.4515C20.125 20.8015 19.6974 20.9765 19.1923 20.9765H5.8077Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListViewIcon);
export default __webpack_public_path__ + "static/media/list-view-icon.1e98f6c07abb660048deaf5444e5b54f.svg";
export { ForwardRef as ReactComponent };